<template>
    <div
        class="btnComponent"
        :style="{width:btnWidth}"
    >
        {{title}}
    </div>
</template>
<script>
export default {
  props: {
    btnWidth: {
      type: String,
      default: '80%',
    },
    title: {
      type: String,
      default: '立即参与活动',
    },
  },
};
</script>
<style scoped lang="scss">
.btnComponent {
    height: 100px;
    background: url('../../../assets/img/pullNew/btnBg.png') no-repeat;
    background-size: 100% 100%;
    margin: -30px auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
    color: #733D08;
    animation:mymove 5s infinite;
}
@keyframes mymove
{
    0%{
    transform: scale(1);
    }
    25%{
        transform: scale(0.9);
    }
    50%{
        transform: scale(1);
    }
    75%{
        transform: scale(0.9);
    }
    100%{
        transform: scale(1);
    }

}
</style>
